import React from "react";
import TemplateCard from "../TemplateCard";

import { useGiveReaction } from "../../functions/templatesHook";


export interface Template {
    _id: string;
    title: string;
    description: string;
    price: number;
    image: string;
    category: 'ecommerce' | 'portfolio' | 'business' | 'blog' | 'logistics' | 'technology' | 'education' | 'marketplace' | 'music';  // Agregado technology
    features: string[];
    pages: string[]; // Agregado pages
    previewImages: string[];
    demoUrl: string;  // Agregado demoUrl
    likes: Reaction;
  dislikes: Reaction;
    reviews?: number;
  }
  

  
interface Reaction {
  count: number;
  users: string[];
}



interface TemplateGridProps {
  templates: Template[];
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const TemplateGrid: React.FC<TemplateGridProps> = ({ templates, currentPage, totalPages, onPageChange }) => {


  const { mutate } = useGiveReaction();

  const handleReaction = (templateId: string, reaction: 'like' | 'dislike') => {
    mutate({ templateId, reaction });
  };
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-navy-800">Featured Templates</h2>
          <p className="mt-4 text-lg text-gray-600">Start with our most popular designs</p>
        </div>

        {/* Templates Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {templates.map((template) => (
            <TemplateCard
             key={template._id}
              template={template}
              onLike={() => handleReaction(template._id, 'like')}
              onDislike={() => handleReaction(template._id, 'dislike')}
              
              />

          ))}
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center mt-8 space-x-2">
            <button
              type="button"
              className={`px-4 py-2 rounded-md border transition ${
                currentPage === 1 ? "bg-gray-200 cursor-not-allowed" : "bg-white hover:bg-indigo-100"
              }`}
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                type="button"
                key={index}
                className={`px-4 py-2 rounded-md border transition ${
                  currentPage === index + 1 ? "bg-indigo-600 text-white" : "bg-white hover:bg-indigo-100"
                }`}
                onClick={() => onPageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button
              type="button"
              className={`px-4 py-2 rounded-md border transition ${
                currentPage === totalPages ? "bg-gray-200 cursor-not-allowed" : "bg-white hover:bg-indigo-100"
              }`}
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default TemplateGrid;
